/**
 * @module getClientVersion
 */

import { getClientVersion as getOwaVersion } from 'owa-config';
import { FALLBACK_CLIENT_VERSION } from '../constants';

/**
 * @function
 * To get the client version for Actionable Messages
 * @returns The client version in a Actionable Message defined format
 */

const getClientVersion = () => {
    let clientVersion = FALLBACK_CLIENT_VERSION;
    const owaVersion = getOwaVersion();
    if (owaVersion) {
        clientVersion = owaVersion;
    }
    clientVersion = clientVersion.replace(/[^\d]/g, '');
    clientVersion = `16.${clientVersion.substr(0, 4)}.${clientVersion.substr(
        4,
        4
    )}.${clientVersion.substr(8)}`;
    return clientVersion;
};

export default getClientVersion;
